import Vue from "vue";
import VueRouter from "vue-router";


import ListarCategorias from '@/components/views/categorias/ListarCategorias';
import NuevaCategoria from '@/components/views/categorias/NuevaCategoria';
import EditarCategoria from '@/components/views/categorias/EditarCategoria';

import ListarCargos from '@/components/views/cargos/ListarCargos';
import NuevoCargo from '@/components/views/cargos/NuevoCargo';
import EditarCargo from '@/components/views/cargos/EditarCargo';

import ListarConceptos from '@/components/views/conceptos/ListarConceptos';
import NuevoConcepto from '@/components/views/conceptos/NuevoConcepto';
import EditarConcepto from '@/components/views/conceptos/EditarConcepto';

import ListarSituacionRevista from '@/components/views/situacionrevista/ListarSituacionRevista';
import NuevaSituacionRevista from '@/components/views/situacionrevista/NuevaSituacionRevista';
import EditarSituacionRevista from '@/components/views/situacionrevista/EditarSituacionRevista';

import ListarSindicatos from '@/components/views/sindicatos/ListarSindicatos';
import NuevoSindicato from '@/components/views/sindicatos/NuevoSindicato';
import EditarSindicato from '@/components/views/sindicatos/EditarSindicato';

import ListarRegimenJubilatorio from '@/components/views/regimenjubilatorio/ListarRegimenJubilatorio';
import NuevoRegimenJubilatorio from '@/components/views/regimenjubilatorio/NuevoRegimenJubilatorio';
import EditarRegimenJubilatorio from '@/components/views/regimenjubilatorio/EditarRegimenJubilatorio';

import ListarPlanMedico from '@/components/views/planmedico/ListarPlanMedico';
import NuevoPlanMedico from '@/components/views/planmedico/NuevoPlanMedico';
import EditarPlanMedico from '@/components/views/planmedico/EditarPlanMedico';

import ListarObraSocial from '@/components/views/obrasocial/ListarObraSocial';
import NuevaObraSocial from '@/components/views/obrasocial/NuevaObraSocial';
import EditarObraSocial from '@/components/views/obrasocial/EditarObraSocial';

import ListarModalidadContrataciones from '@/components/views/modalidadcontratacion/ListarModalidadContrataciones';
import NuevaModalidadContratacion from '@/components/views/modalidadcontratacion/NuevaModalidadContratacion';
import EditarModalidadContratacion from '@/components/views/modalidadcontratacion/EditarModalidadContratacion';

import ListarSecciones from '@/components/views/seccion/ListarSecciones';
import NuevaSeccion from '@/components/views/seccion/NuevaSeccion';
import EditarSeccion from '@/components/views/seccion/EditarSeccion';

import ListarTipoLiquidacion from '@/components/views/tipoliquidacion/ListarTipoLiquidacion';
import NuevoTipoLiquidacion from '@/components/views/tipoliquidacion/NuevoTipoLiquidacion';
import EditarTipoLiquidacion from '@/components/views/tipoliquidacion/EditarTipoLiquidacion';

import ListarInstituciones from '@/components/views/institucion/ListarInstituciones';
import NuevaInstitucion from '@/components/views/institucion/NuevaInstitucion';
import EditarInstitucion from '@/components/views/institucion/EditarInstitucion';

import ListarPersonas from '@/components/views/personas/ListarPersonas';
import NuevaPersona from '@/components/views/personas/NuevaPersona';
import EditarPersona from '@/components/views/personas/EditarPersona';
import VerPersona from '@/components/views/personas/VerPersona';

import ListarLegajos from '@/components/views/legajo/ListarLegajos';
import NuevoLegajo from '@/components/views/legajo/NuevoLegajo';
import EditarLegajo from '@/components/views/legajo/EditarLegajo';
import VerLegajo from '@/components/views/legajo/VerLegajo';

import EditarRecibo from '@/components/views/recibo/EditarRecibo';

//import Usuarios from '@/components/views/usuarios/Usuarios';
import EditarPerfil from '@/components/views/usuarios/EditarPerfil';

import ListarLiquidaciones from '@/components/views/liquidaciones/ListarLiquidaciones';
import NuevaLiquidacion from '@/components/views/liquidaciones/NuevaLiquidacion';
import VerLiquidacion from '@/components/views/liquidaciones/VerLiquidacion';
import EditarLiquidacion from '@/components/views/liquidaciones/EditarLiquidacion';

Vue.use(VueRouter);
const rutasCargos = [
    {
        path: "/cargos/listar",
        name:"ListarCargos",
        component: ListarCargos
    },
    {
        path: "/cargo/nuevo",
        name:"NuevoCargo",
        component: NuevoCargo
    },
    {
        path: "/cargo/editar/:id",
        name:"EditarCargo",
        component: EditarCargo
    },
];
const rutasConceptos = [
    {
        path: "/conceptos/listar",
        name:"ListarConceptos",
        component: ListarConceptos
    },
    {
        path: "/concepto/nuevo",
        name:"NuevoConcepto",
        component: NuevoConcepto
    },
    {
        path: "/concepto/editar/:id",
        name:"EditarConcepto",
        component: EditarConcepto
    },
];
const rutasSitRevista = [
    {
        path: "/situacionrevista/listar",
        name:"ListarSituacionRevista",
        component: ListarSituacionRevista
    },
    {
        path: "/situacionrevista/nueva",
        name:"NuevaSituacionRevista",
        component: NuevaSituacionRevista
    },
    {
        path: "/situacionrevista/editar/:id",
        name:"EditarSituacionRevista",
        component: EditarSituacionRevista
    },
];
const rutasRegimenJubilatorio = [
    {
        path: "/regimenjubilatorio/listar",
        name:"ListarRegimenJubilatorio",
        component: ListarRegimenJubilatorio
    },
    {
        path: "/regimenjubilatorio/nuevo",
        name:"NuevoRegimenJubilatorio",
        component: NuevoRegimenJubilatorio
    },
    {
        path: "/regimenjubilatorio/editar/:id",
        name:"EditarRegimenJubilatorio",
        component: EditarRegimenJubilatorio
    },
];

const rutasTiposLiquidacion = [
    {
        path: "/tipo-liquidacion/listar",
        name:"ListarTipoLiquidacion",
        component: ListarTipoLiquidacion
    },
    {
        path: "/tipoliquidacion/nueva",
        name:"NuevoTipoLiquidacion",
        component: NuevoTipoLiquidacion
    },
    {
        path: "/tipoliquidacion/editar/:id",
        name:"EditarTipoLiquidacion",
        component: EditarTipoLiquidacion
    },
];
const rutasPlanMedico = [
    {
        path: "/planmedico/listar",
        name:"ListarPlanMedico",
        component: ListarPlanMedico
    },
    {
        path: "/planmedico/nuevo",
        name:"NuevoPlanMedico",
        component: NuevoPlanMedico
    },
    {
        path: "/planmedico/editar/:id",
        name:"EditarPlanMedico",
        component: EditarPlanMedico
    },
];
const rutasSindicatos = [
    {
        path: "/sindicatos/listar",
        name:"ListarSindicatos",
        component: ListarSindicatos
    },
    {
        path: "/sindicato/nuevo",
        name:"NuevoSindicato",
        component: NuevoSindicato
    },
    {
        path: "/sindicato/editar/:id",
        name:"EditarSindicato",
        component: EditarSindicato
    },
];
const rutasObraSocial = [
    {
        path: "/obrasocial/listar",
        name:"ListarObraSocial",
        component: ListarObraSocial
    },
    {
        path: "/obrasocial/nuevo",
        name:"NuevaObraSocial",
        component: NuevaObraSocial
    },
    {
        path: "/obrasocial/editar/:id",
        name:"EditarObraSocial",
        component: EditarObraSocial
    },
];
const rutasModalidadContratacion = [
    {
        path: "/modalidad-contratacion/listar",
        name:"ListarModalidadContrataciones",
        component: ListarModalidadContrataciones
    },
    {
        path: "/modalidad-contratacion/nuevo",
        name:"NuevaModalidadContratacion",
        component: NuevaModalidadContratacion
    },
    {
        path: "/modalidad-contratacion/editar/:id",
        name:"EditarModalidadContratacion",
        component: EditarModalidadContratacion
    },
];
const rutasLegajo = [
    {
        path: "/legajos/listar",
        name:"ListarLegajos",
        component: ListarLegajos
    },
    {
        path: "/legajos/nuevo",
        name:"NuevoLegajo",
        component: NuevoLegajo
    },
    {
        path: "/legajos/editar/:id",
        name:"EditarLegajo",
        component: EditarLegajo
    },
    {
        path: "/legajo/ver/:id",
        name:"VerLegajo",
        component: VerLegajo
    }
];
const rutasSeccion = [
    {
        path: "/seccion/listar",
        name:"ListarSecciones",
        component: ListarSecciones
    },
    {
        path: "/seccion/nueva",
        name:"NuevaSeccion",
        component: NuevaSeccion
    },
    {
        path: "/seccion/editar/:id",
        name:"EditarSeccion",
        component: EditarSeccion
    },
];
const rutasInstitucion = [
    {
        path: "/institucion/listar",
        name:"ListarInstituciones",
        component: ListarInstituciones
    },
    {
        path: "/institucion/nueva",
        name:"NuevaInstitucion",
        component: NuevaInstitucion
    },
    {
        path: "/institucion/editar/:id",
        name:"EditarInstitucion",
        component: EditarInstitucion
    },
];
const rutasRecibos = [
    {
        path: "/recibos/editar/:id",
        name:"EditarRecibo",
        component: EditarRecibo
    },
];
const rutasLiquidacion = [
    {
        path: "/liquidacion/listar",
        name:"ListarLiquidaciones",
        component: ListarLiquidaciones
    },
    {
        path: "/liquidacion/nueva",
        name:"NuevaLiquidacion",
        component: NuevaLiquidacion
    },
    {
        path: "/liquidacion/ver/:id",
        name:"VerLiquidacion",
        component: VerLiquidacion
    },
    {
        path: "/liquidacion/editar/:id",
        name:"EditarLiquidacion",
        component: EditarLiquidacion
    }
];
const rutasPersonas = [
    {
        path: "/personas/listar",
        name:"ListarPersonas",
        component: ListarPersonas,
    },
    {
        path: "/personas/nueva",
        name:"NuevaPersona",
        component: NuevaPersona
    },
    {
        path: "/personas/editar/:id",
        name:"EditarPersona",
        component: EditarPersona
    },
    {
        path: "/personas/ver/:id",
        name:"VerPersona",
        component: VerPersona
    },
];
const routes=[
    {
        path: "/perfil/editar",
        name:"EditarPerfil",
        component: EditarPerfil
    }, 
    {
        path: "/listar-categorias",
        name:"ListarCategorias",
        component: ListarCategorias
    },    
    {
        path: "/nueva-categoria",
        name:"NuevaCategoria",
        component: NuevaCategoria
    },
    {
        path: "/editar/categoria/:id",
        name:"EditarCategoria",
        component: EditarCategoria
    },
    ...rutasCargos,
    ...rutasSitRevista,
    ...rutasSindicatos,
    ...rutasRegimenJubilatorio,
    ...rutasPlanMedico,
    ...rutasObraSocial,
    ...rutasModalidadContratacion,
    ...rutasSeccion,
    ...rutasLegajo,
    ...rutasInstitucion,
    ...rutasLiquidacion,
    ...rutasPersonas,
    ...rutasConceptos,
    ...rutasTiposLiquidacion,
    ...rutasRecibos,

];
const router = new VueRouter({
    mode: 'history',
   // base: process.env.BASE_URL,
    routes,
   // linkExactActiveClass: "mm-active",
  })
export default router